<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="false">
  <form [formGroup]="redeemPromocodeForm">
    <ion-label class="title">{{ 'ACCOUNT.redeem.title' | translate }}</ion-label>
    <ng-container>
      <ion-label>
        {{ 'ACCOUNT.redeem.redeemNow1' | translate }}
        <br />
        {{ 'ACCOUNT.redeem.redeemNow2' | translate }}
      </ion-label>
      <ion-item class="item-input item-interactive" mode="md">
        <ion-input
          label="{{ 'ACCOUNT.redeem.capitalised' | translate }}"
          labelPlacement="stacked"
          autocomplete="off"
          type="text"
          formControlName="code"
        ></ion-input>
      </ion-item>
      <div class="ion-input__errors">
        <span *ngIf="redeemPromocodeForm.controls.code.hasError('required') && redeemPromocodeForm.touched">
          {{ 'ACCOUNT.redeem.empty' | translate }}
        </span>
      </div>
      <ion-button (click)="redeemPromocode()" mode="ios">{{ 'ACCOUNT.redeem.cta' | translate }}</ion-button>
    </ng-container>
  </form>
</ion-content>
